import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
export function EvaSchiffererTerminVereinbarenPage() {
  useEffect(() => {
    // Ensure the div exists before loading the script
    const embedDiv = document.getElementById('zeeg-embed-eva-schifferer');
    if (!embedDiv) {
      console.error('Zeeg embed div not found');
      return;
    }
    // Load Zeeg embed script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.zeeg.me/embed.min.js';
    script.setAttribute('data-user', 'eva-schifferer');
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-1947">
      <Header data-id="element-1948" />
      <main className="w-full pt-[152px]" data-id="element-1949">
        <div className="max-w-6xl mx-auto py-16 px-6 md:px-12" data-id="element-1950">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1951">
            Termin vereinbaren
          </h1>
          <div className="prose prose-lg max-w-none" data-id="element-1952">
            <p className="text-lg text-gray-600 mb-8" data-id="element-1953">
              Ich freue mich auf unser Gespräch. Buchen Sie hier direkt einen
              Termin für ein kostenfreies Kennenlerngespräch oder eine erste
              Sitzung.
            </p>
            {/* Zeeg inline embed */}
            <div className="mt-8" data-id="element-1954">
              <div className="zeeg-inline-widget" id="zeeg-embed-eva-schifferer" style={{
              width: 'auto',
              height: '1000px'
            }} data-id="element-1955"></div>
            </div>
            <div className="text-center mt-8" data-id="element-1956">
              <p className="text-gray-600" data-id="element-1957">
                Oder kontaktieren Sie mich direkt per{' '}
                <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1958">
                  E-Mail
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <EvaSchiffererFooter data-id="element-1959" />
    </div>;
}